import {InjectionKey} from 'vue'

const downloadFileKey = Symbol() as InjectionKey<Function>
const uploadFilesKey = Symbol() as InjectionKey<Function>
const getFileIconKey = Symbol() as InjectionKey<Function>

export {
    downloadFileKey,
    uploadFilesKey,
    getFileIconKey
}